<template>
  <div class="globalTourism">
    <div class="module">
      <ul class="ul">
        <li class="li" v-for="(item, index) in moduleList" :key="index">
          <div class="img">
            <img :src="item.img" alt="" />
          </div>
          <div class="name">
            {{ item.name }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'globalTourism',
  data() {
    return {
      moduleList: [
        {
          img: require('./img/anji.png'),
          name: '安吉'
        },
        {
          img: require('./img/deqing.png'),
          name: '德清'
        },
        {
          img: require('./img/smart.png'),
          name: '智慧大云'
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.globalTourism {
  .module {
    width: 100%;
    height: 646px;
    background: #ffffff;
    border: 1px solid #979797;
    margin: 0 auto;
    .ul {
      display: flex;
      justify-content: space-evenly;
      .li {
        margin-top: 144px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .img {
          img {
            width: 429px;
            height: 294px;
          }
        }
        .name {
          text-align: center;
          width: 300px;
          height: 33px;
          font-size: 24px;
          font-family: 'PingFang';
          color: #000000;
          line-height: 33px;
          margin-top: 52px;
        }
      }
    }
  }
}
</style>
